/* eslint-disable import/prefer-default-export */
export const setCookie = (cname: string, cvalue: string, exdays = 7): void => {
    let expires = '';
    if (exdays > 0) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        expires = `expires=${d.toUTCString()};`;
    }

    const encodedValue = btoa(cvalue);

    document.cookie = `${cname}=${encodedValue};${expires}path=/`;
};
